import moment from 'moment';

export const genOptimizerLocalKey = ({ accountId, userId }) => {
    return [
        'LAST_OPTIMIZER',
        `accountId_${accountId}`,
        `userId_${userId}`,
    ].join('::');
};

export const parseOptimizersToViews = (optimizers = []) => {
    let order = 100009;
    const views = optimizers.reduce((arr, optimizer) => {
        const view = createOptimizerView(optimizer, order);

        arr.push(view);
        order++;
        return arr;
    }, []);

    return views;
};

const createOptimizerView = (optimizer = {}, order) => {
    const {
        id,
        currency,
        name,
        options,
        status,
        updatedAt,
        createdAt,
        startedAt,
        lastOptimizedAt,
        workspaceId,
    } = optimizer;

    let { goalMetric = undefined } = optimizer;
    // goalMetric = R.toLower(goalMetric);

    const globalFilterTagList = [];
    const campaigns = R.pathOr([], ['campaigns'])(options);

    for (const c of campaigns) {
        const frags = c.id.split('/');

        const filter = {
            filterBy: {
                level: 'campaign',
                value: frags[frags.length - 1],
            },
            type: 'ids',
        };
        globalFilterTagList.push(filter);
    }

    if (globalFilterTagList.length < 1) {
        globalFilterTagList.push({
            filterBy: {
                level: 'campaign',
                value: 'To Block Calling campaign list if no campaign selected',
            },
            type: 'ids',
        });
    }

    return {
        view_title: name,
        viewTitle: name,
        order,
        config: {
            type: 'overview',
            widgets: [
                {
                    id: 'optimizer-budget',
                    type: 'graph',
                    columns: ['impressions', 'clicks'],
                    subType: 'line',
                    comboChart: {
                        yAxis1: {
                            type: 'bar',
                            metric: 'spend',
                        },
                        yAxis2: {
                            type: 'bar',
                            metric: '',
                        },
                        yAxis3: {
                            type: 'line',
                            metric: '',
                        },
                    },
                    dimensionIds: ['campaign'],
                    selectedxAxis: 'dailyBudgetAmount',
                    selectedMetric: 'dailyBudgetAmount',
                    selectedGraphType: 'line',
                    mmo: 'budgetHistory', //
                    filterTagList: globalFilterTagList, //
                    widget_title: 'Budget Optimized Record', //
                },
                {
                    id: 'optimizer-goalMetric',
                    type: 'graph',
                    columns: ['impressions', 'clicks'],
                    subType: 'line',
                    comboChart: {
                        yAxis1: {
                            type: 'bar',
                            metric: 'spend',
                        },
                        yAxis2: {
                            type: 'bar',
                            metric: '',
                        },
                        yAxis3: {
                            type: 'line',
                            metric: '',
                        },
                    },
                    dimensionIds: ['campaign'],
                    filterTagList: globalFilterTagList,
                    // selectedxAxis: 'cpc',
                    selectedxAxis: goalMetric,
                    // selectedMetric: 'cpc',
                    selectedMetric: goalMetric,
                    selectedGraphType: 'line',
                    widget_title: `Goal - ${goalMetric}`, //
                },
                {
                    id: 'optimizer-adTable',
                    page: {
                        rowNum: 30,
                    },
                    sort: {
                        name: 'clicks',
                        isDesc: true,
                    },
                    type: 'pivotTable',
                    columns: [
                        'status',
                        'subChannels',
                        'budget',
                        'spend',
                        'impressions',
                        'clicks',
                        'cpc',
                        'ctr',
                        'cpm',
                        'pixelRoas',
                    ],
                    barColumns: ['clicks', goalMetric],
                    dimensionIds: ['campaign'],
                    filterTagList: globalFilterTagList,
                    widget_title: 'Performance',
                },

                // TODO getTable hidden for campaigns
                // {
                //     id: 'optimizer-hidden-to-get-all-campaign-list',
                //     page: { rowNum: 30 },
                //     sort: { name: 'clicks', isDesc: true },
                //     type: 'pivotTable',
                //     columns: [
                //         'status',
                //         'subChannels',
                //         'budget',
                //         'spend',
                //         'impressions',
                //         'clicks',
                //         'cpc',
                //         'ctr',
                //         'cpm',
                //     ],
                //     barColumns: ['clicks', goalMetric],
                //     dimensionIds: ['campaign'],
                //     filterTagList: [],
                //     widget_title: 'Hidden',
                // },
            ],
            dateFilter: {
                type: 'range',
                values: {
                    range: {
                        // TODO: Change after done => just for developing
                        // from: '2022-07-15',
                        from: moment(startedAt).format('YYYY-MM-DD'),
                        to: moment(Date.now()).format('YYYY-MM-DD'),
                    },
                },
                todayExcluded: false,
            },
            viewLayout: {
                layout: [
                    {
                        h: 12,
                        i: 'optimizer-budget',
                        w: 3,
                        x: 0,
                        y: 0,
                        moved: false,
                        static: true,
                    },
                    {
                        h: 12,
                        i: 'optimizer-goalMetric',
                        w: 3,
                        x: 3,
                        y: 0,
                        moved: false,
                        static: true,
                    },
                    {
                        h: 12,
                        i: 'optimizer-adTable',
                        w: 6,
                        x: 0,
                        y: 12,
                        moved: false,
                        static: true,
                    },
                    // TODO getTable hidden for campaign
                    // {
                    //     h: 1,
                    //     i: 'optimizer-hidden-to-get-all-campaign-list',
                    //     w: 6,
                    //     x: 0,
                    //     y: 28,
                    //     moved: false,
                    //     static: true,
                    // },
                ],
                disabled: false,
                widthUpdated: true,
            },
            filterTagList: [],
            comparisonDateFilter: {},
        },
        isDefault: false,
        isPrivate: false,
        parentId: null,
        type: 'optimizer',
        subtype: 'normal',
        logoMedia: null,
        id,
        viewKey:
            '8e7f6a0ec70e65d3f90ac2cb31c57791c4b4089fb3a23f300b498d6e1e222bbb',
        isViewable: true,
        isDeletable: false,
    };
};
